import React, { useRef, useState, useEffect, useContext } from "react";
import logo from "../image/ada-logo.svg";
import "../css/login.sass";
import {
    InputAdornment,
    IconButton,
    TextField,
    FormControl,
    OutlinedInput,
    InputLabel,
} from "@mui/material";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { post } from "../utils/api";
import apiServer from "../constants/apiServer";
import { AuthContext } from "../context/AuthProvider";
import { Navigate } from "react-router-dom";
import AdaAlert from "../common/AdaAlert";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const Login = () => {
    const emailRef = useRef();
    const { executeRecaptcha } = useGoogleReCaptcha();

    const [loginInfo, setLoginInfo] = useState({
        email: "",
        password: "",
    });

    const [showPassword, setShowPassword] = useState(false);
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");
    const { setAuth } = useContext(AuthContext);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setLoginInfo((prevInfo) => {
            return {
                ...prevInfo,
                [name]: value,
            };
        });
    };

    const { email, password } = loginInfo;

    const handleLogin = async (event) => {
        if (!executeRecaptcha) return
        event.preventDefault();
        const formData = new FormData();
        const gRecaptchaToken = await executeRecaptcha("login");
        formData.append("email", loginInfo.email);
        formData.append("password", loginInfo.password);
        formData.append("gRecaptchaToken", gRecaptchaToken);
        try {
            const { data, status } = await post(apiServer.auth.login, formData);
            console.log("login data", data);

            // Cookie-based auth: backend returns { message, userId } with status 201.
            // The JWT is stored in an httpOnly cookie by the browser automatically
            // (axios client has withCredentials: true in src/utils/api.js).
            if (status === 201) {
                localStorage.setItem("userId", data.userId);
                setAuth([
                    {
                        userId: data.userId,
                        identity: data.admin || data.user,
                        permission: data.role_id,
                    },
                ]);
                setSuccess(data.message);
            } else if (status === 400 || data.success === false) {
                setAuth([
                    {
                        identity: "",
                        permission: "",
                    },
                ]);
                setError(data.message);
            } else if (status >= 400 || data.success === false) {
                setAuth([
                    {
                        identity: "",
                        permission: "",
                    },
                ]);
                setError("Email or Password should not be null");
            }
        } catch (err) {
            console.log("error is ", err);
            setAuth({
                identity: "",
                permission: "",
            });
            setError(err.message);
        }
        setShowPassword(false);
    };

    useEffect(() => {
        emailRef.current.focus();
    }, []);

    return (
        <>
            {success && <Navigate to="/dashboard" replace="true" />}
            <div className="login-page-section">
                <img src={logo} alt="ada-logo" className="login-logo-img" />
                <div className="login-container">
                    <h2>Login</h2>
                    {/* <img src={logo} alt="ada-logo"/> */}
                    <form onSubmit={handleLogin}>
                        {/* <TextField id="outlined-basic" label="Outlined" variant="outlined" /> */}
                        <TextField
                            id="email"
                            label="Email *"
                            type="email"
                            name="email"
                            value={email}
                            ref={emailRef}
                            fullWidth
                            onChange={handleChange}
                        />
                        <FormControl>
                            <InputLabel htmlFor="standard-adornment-password">
                                Password
                            </InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-password"
                                type={showPassword ? "text" : "password"}
                                name="password"
                                value={password}
                                onChange={handleChange}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => {
                                                setShowPassword(!showPassword);
                                            }}
                                            onMouseDown={(event) => {
                                                event.preventDefault();
                                            }}
                                            edge="end"
                                        >
                                            {showPassword ? (
                                                <MdVisibilityOff />
                                            ) : (
                                                <MdVisibility />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                label="Password"
                            />
                        </FormControl>
                        <button className="login-btn">Login</button>
                    </form>
                    {/* <span>Need an account ? </span> */}
                </div>
                <span>(V-1.0.9)</span>
                {error && <AdaAlert message={error} type="error" />}
                {success && <AdaAlert message={success} type="success" />}
            </div>
        </>
    );
};

export default Login;
